import { Button } from "components/Button";
import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";

interface StyledAccessibilityMenuButtonProps extends ThemeProps {
  $enableUxImprovements?: boolean;
}

export const StyledAccessibilityMenuButton = styled(Button)<StyledAccessibilityMenuButtonProps>`
  text-align: left;
  font-size: ${({ $enableUxImprovements, theme }) => ($enableUxImprovements ? theme.font.size._14 : theme.font.size._16)};

  margin: 1rem 0.9rem;

  .content {
    display: flex;
    gap: 0rem 0.5rem;
  }

  * {
    color: ${(props: ThemeProps) => props.theme.palette.neutral.black};
  }

  svg {
    height: 1.2rem;
  }
`;
